import React from 'react';

export function CharCount({ value, minLength, maxLength }) {
  if (!minLength && !maxLength) return null;
  
  const len = String(value ?? '').length;
  let colorClass = 'text-gray-400';
  let message = '';

  if (maxLength) {
    if (len > maxLength) {
      colorClass = 'text-red-500';
    } else if (len >= maxLength * 0.9) {
      colorClass = 'text-amber-500';
    }
  }

  if (minLength && len < minLength) {
    colorClass = 'text-red-500';
    if (len > 0) {
      message = ` (min ${minLength})`;
    }
  }

  return (
    <div className="flex justify-end items-center mt-1">
      <span className={`text-xs ${colorClass}`}>
        {maxLength ? `${len}/${maxLength}` : `${len}`} {message}
      </span>
    </div>
  );
}
